import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../helpers/reducerRegistry'
import { handleOwnershipAndGroupData } from '../../../helpers'
import { getOwnershipAndGroup } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/peerAnalysis/ownershipAndGroup',
  initialState: {
    isLoading: true,
    ids: [],
    data: {},
  },
  reducers: {
    removeOwnershipAndGroup: (state, { payload }) => {
      state.ids = state.ids.filter((item) => item !== payload)
      delete state.data[payload]
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOwnershipAndGroup.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(
      getOwnershipAndGroup.fulfilled,
      (state, { payload = [] }) => {
        state.isLoading = false
        state.ids = payload.map((item) => item.organizationId)
        state.data = handleOwnershipAndGroupData(payload, state.ids)
      },
    )
    builder.addCase(
      getOwnershipAndGroup.rejected,
      (state, { payload = {} }) => {
        state.isLoading = payload.isLoading
      },
    )
  },
})

export const selectOwnershipAndGroupItem = (rowId, colId) => (state) =>
  state[slice.name].data[rowId][colId]
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectIds = (state) => state[slice.name].ids

export const { removeOwnershipAndGroup } = slice.actions

register(slice.name, slice.reducer)
